import { useContext } from 'react';
import PropTypes from 'prop-types';
import Table from 'ypf-pas-general-ui-components/dist/Table/Table';

import StatusProvider from '../StatusProvider/StatusProvider';
import { checkRol } from '../../security';
import { solicitante } from '../../security/constantsRols';
import { checkDuplicityService } from '../../services/serviceRequest';
import useToast from '../../hooks/useToast';
import LoaderContext from '../../context/LoaderProvider';
import { CALL_ORIGIN_ENUM } from '../../utils/dataStatus';

import Checkbox from './Checkbox';

const ProvidersTable = (props) => {
  const {
    providers,
    setShowModalAssign,
    setIsChecked,
    isChecked,
    setProviderData,
    canChangeValue,
    idRequest,
    calledFrom,
    setDuplicatedData,
    setShowTable,
    setShowModal,
    idService,
    idsEventoPozo,
    tipoAsignacionEnum,
    ubicacionStr,
    tipoUbicacion
  } = props;

  const { setNewToast } = useToast();
  const { setLoader } = useContext(LoaderContext);

  const handleCheckDuplicity = async (providerData) => {
    setLoader(true);
    try {
      const body = {
        idSolicitud: Number(idRequest),
        tipoAsignacionEnum,
        ubicacion: {
          tipoUbicacionEnum: tipoUbicacion,
          ubicacionNombre: ubicacionStr
        },
        servicios: [
          {
            idServicio: idService,
            contrato: providerData?.numeroContrato,
            idProveedor: providerData.idProveedor
          }
        ],

        idsEventoPozo
      };

      const res = await checkDuplicityService(body);

      if (res?.existenDuplicados) {
        setDuplicatedData(res.solicitudesDuplicadas);
        setShowModal(calledFrom === CALL_ORIGIN_ENUM.assign);

        setShowTable(calledFrom === CALL_ORIGIN_ENUM.reassign);
      } else if (!res?.existenDuplicados && calledFrom === CALL_ORIGIN_ENUM.assign) {
        setShowModalAssign(true);
      }
    } catch (err) {
      setNewToast(err?.message);
    } finally {
      setLoader(false);
    }
  };

  const assignProvider = ({ cell }) => {
    const state = cell?.row?.original?.aceptado;

    if (isChecked === cell?.row?.index) {
      setProviderData(cell?.row?.original);
    }

    return (
      <>
        {state && (
          <Checkbox
            checked={isChecked === cell?.row?.index}
            onChange={() => {
              if (isChecked !== cell?.row?.index) {
                handleCheckDuplicity(cell?.row?.original);
              }
              setShowTable(false);
              setIsChecked(cell?.row?.index);

              if (canChangeValue && isChecked === cell?.row?.index) {
                setIsChecked(null);
              }
            }}
          />
        )}
      </>
    );
  };

  const statusRequest = ({ cell }) => {
    const status = cell?.row?.original.aceptado;

    return <StatusProvider idStatus={status} />;
  };

  const columnsProviders = [
    {
      Header: 'Proveedor',
      accessor: 'proveedor',
      hideSort: true
    },
    {
      Header: 'Contrato',
      accessor: 'numeroContrato',
      hideSort: true
    },
    {
      Header: 'Notifica',
      accessor: 'tipoNotificacion',
      hideSort: true
    },
    {
      Header: 'Estado',
      accessor: 'state',
      hideSort: true,
      Cell: statusRequest
    }
  ];

  return (
    <Table
      columns={
        checkRol(solicitante)
          ? [
              ...columnsProviders,
              {
                Header: 'Asignar',
                accessor: 'asign',
                hideSort: true,
                Cell: assignProvider
              }
            ]
          : columnsProviders
      }
      data={providers}
      type="light"
    />
  );
};

ProvidersTable.propTypes = {
  providers: PropTypes.arrayOf(
    PropTypes.shape({
      aceptado: PropTypes.bool,
      idProveedor: PropTypes.number,
      idSolicitudServicio: PropTypes.number,
      numeroContrato: PropTypes.number,
      proveedor: PropTypes.string,
      tipoNotificacion: PropTypes.string
    })
  ).isRequired,
  setIsChecked: PropTypes.func.isRequired,
  isChecked: PropTypes.number,
  setProviderData: PropTypes.func.isRequired,
  setShowModalAssign: PropTypes.func,
  canChangeValue: PropTypes.bool,
  idRequest: PropTypes.string.isRequired,
  calledFrom: PropTypes.string.isRequired,
  setDuplicatedData: PropTypes.func.isRequired,
  setShowTable: PropTypes.func,
  setShowModal: PropTypes.func,
  idService: PropTypes.number.isRequired,
  idsEventoPozo: PropTypes.arrayOf(PropTypes.number),
  tipoAsignacionEnum: PropTypes.number.isRequired,
  tipoUbicacion: PropTypes.number.isRequired,
  ubicacionStr: PropTypes.string.isRequired
};

ProvidersTable.defaultProps = {
  setShowModalAssign: () => {
    /* empty */
  },
  isChecked: null,
  canChangeValue: false,
  setShowTable: () => {
    /* empty */
  },
  setShowModal: () => {
    /* empty */
  },
  idsEventoPozo: []
};

export default ProvidersTable;
